import axios from 'axios'
// import qs from 'qs'
// import config from '../config'
import * as apiConstant from './api-constant'
// import { Message, Loading } from 'element-ui'
import { Message } from 'element-ui'

/**
 *
 * @param {string} constant url常量字符串
 * @param {object} data 参数对象
 * @param {function} callback 回调函数
 * @param {function} errorCallback 返回码不为0时的回调函数
 * @param {function} catchCallback 断网或网络问题时回调函数
 */
export const post = (constant, data = {}, callback, errorCallback, catchCallback) => {
  // let loadingInstance = Loading.service({
  //   lock: true,
  //   text: 'Loading',
  //   spinner: 'el-icon-loading',
  //   background: 'rgba(0, 0, 0, 0.7)'
  // })
  let url = apiConstant[constant]
  // axios.defaults.baseURL = config.baseURL
  // axios.defaults.baseURL = '/oms'
  axios.defaults.headers.post['Content-Type'] = 'application/json;charse=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    // loadingInstance.close()
    if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 10016) {
      window.location.hash = '#/login'
    } else {
      Message({
        type: 'error',
        message: res.data.msg
      })
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    // loadingInstance.close()
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

export const testpost = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let url = constant
  // axios.defaults.baseURL = config.baseURL
  // axios.defaults.baseURL = '/oms'
  axios.defaults.headers.post['Content-Type'] = 'application/json;charse=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    // loadingInstance.close()
    if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 10016) {
      window.location.hash = '#/login'
    } else {
      Message({
        type: 'error',
        message: res.data.msg
      })
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    // loadingInstance.close()
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

export const purePost = (constant, data = {}, callback, errorCallback, catchCallback) => {
  let url = apiConstant[constant]
  // axios.defaults.baseURL = config.baseURL
  // axios.defaults.baseURL = '/oms'
  axios.defaults.headers.post['Content-Type'] = 'application/json;charse=UTF-8'
  axios.defaults.headers.post['ctype'] = 4
  axios.post(
    url,
    JSON.stringify(data)
  ).then((res) => {
    if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 10016) {
      window.location.hash = '#/login'
    } else {
      Message({
        type: 'error',
        message: res.data.msg
      })
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

// 打包下载
export const getFile = url => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.get['Content-Type'] = 'application/json;charse=UTF-8'
    axios.defaults.headers.get['ctype'] = 3
    axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*'
    axios.get(
      url,
      {responseType: 'arraybuffer'}
    ).then(data => {
      resolve(data.data)
    }).catch(error => {
      console.log(error)
      reject(error.toString())
    })
  })
}
export const file = (constant, data = {}, callback, errorCallback, catchCallback) => {
  // let loadingInstance = Loading.service({
  //   lock: true,
  //   text: 'Loading',
  //   spinner: 'el-icon-loading',
  //   background: 'rgba(0, 0, 0, 0.7)'
  // })
  let url = apiConstant[constant]
  axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
  axios.defaults.headers.post['ctype'] = 4
  axios.post(
    url,
    data
  ).then((res) => {
    // loadingInstance.close()
    if (res.data.code === 0) {
      typeof callback === 'function' && callback(res.data)
    } else if (res.data.code === 10016) {
      window.location.hash = '#/login'
    } else {
      Message({
        type: 'error',
        message: res.data.msg
      })
      typeof errorCallback === 'function' && errorCallback(res.data)
    }
  }).catch((error) => {
    // loadingInstance.close()
    typeof catchCallback === 'function' && catchCallback(error)
  })
}

export const upImg = () => {
  // 删除file对象
  let del = () => {
    let dom = document.querySelector('.upImgFile')
    document.querySelector('body').removeChild(dom)
  }
  if (document.querySelector('.upImgFile')) {
    del()
  }
  let fn = new Promise((resolve, reject) => {
    let fileInput = document.createElement('input')
    fileInput.type = 'file'
    fileInput.accept = 'image/*,video/*'
    fileInput.className = 'upImgFile'
    fileInput.style.display = 'none'
    document.querySelector('body').appendChild(fileInput)
    document.querySelector('.upImgFile').click()
    fileInput.onchange = (e) => {
      let form = new FormData()
      form.append('file', e.target.files[0])
      form.append('parentId', '935979670716137472')
      form.append('businessType', 'oms')
      form.append('originalName', '')
      form.append('tag', 'image/article')
      file('FILE_UPLOAD', form, (res) => {
        Message({
          type: 'success',
          message: '上传成功'
        })
        resolve(res.data.fileUrl)
      })
    }
  })
  return fn
}



// WEBPACK FOOTER //
// ./src/assets/js/api.js